import * as React from 'react';
import Input from 'antd/lib/input';
import classNames from 'classnames';

import { InputProps } from 'antd/lib/input/Input';

interface InputCCNumberProps extends InputProps {
	showPlaceholder?: boolean;
}
interface InputCCNumberState {
	isFocus?: boolean;
}

export default class InputCCNumber extends React.Component<InputCCNumberProps, InputCCNumberState> {
	state = { isFocus: false };

	private inputRef: any;

	saveInput = (inputRef: any) => {
		this.inputRef = inputRef;
	};

	focus() {
		this.inputRef.focus();
	}

	onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
		this.setState({
			isFocus: true,
		});
		if (this.props.onFocus) {
			this.props.onFocus(e);
		}
	};

	onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		this.setState({
			isFocus: false,
		});
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
	};

	get placeholder() {
		const { isFocus } = this.state;
		const { placeholder } = this.props;
		return !isFocus ? this.ccFormat(placeholder, true) : '';
	}

	ccFormat(value?: string, isPlaceholder?: boolean) {
		if (!value) {
			return undefined;
		}
		const v = value.replace(/\s+/g, '').replace(/[^0-9●]/gi, '');
		const matches = v.match(/\d{4,16}/g);
		const match = (matches && matches[0]) || '';
		const parts = [];

		for (let i = 0, len = match.length; i < len; i += 4) {
			let val = match.substring(i, i + 4);
			if (i !== 12 && isPlaceholder) {
				val = val.replace(/./g, '●');
			}
			parts.push(val);
		}

		if (parts.length) {
			return parts.join(' ');
		} else {
			return value;
		}
	}

	render() {
		const { className, size, showPlaceholder, value, ...restProps } = this.props;
		const formattedValue = this.ccFormat(value as string);

		return (
			<Input
				{...restProps}
				value={formattedValue}
				ref={this.saveInput}
				size={size}
				className={classNames(className)}
				onFocus={this.onFocus}
				onBlur={this.onBlur}
				placeholder={this.placeholder}
			/>
		);
	}
}
